import { render, staticRenderFns } from "./LedesList.vue?vue&type=template&id=23e5e0e3&"
import script from "./LedesList.vue?vue&type=script&lang=js&"
export * from "./LedesList.vue?vue&type=script&lang=js&"
import style0 from "./LedesList.vue?vue&type=style&index=0&id=23e5e0e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports